import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type ThemeChoice = 'light' | 'dark' | 'auto';

interface SettingsState {
  theme: ThemeChoice;
  fontScale: number; // 0.75 – 2.0
  setTheme: (t: ThemeChoice) => void;
  setFontScale: (s: number) => void;
}

export const useSettings = create<SettingsState>()(
  persist(
    (set) => ({
      theme: 'auto',
      fontScale: 1,
      setTheme: (t) => set({ theme: t }),
      setFontScale: (s) => set({ fontScale: Math.max(0.75, Math.min(2, s)) }),
    }),
    { name: 'cyclotron.settings' }
  )
);

export function applyFontScale(scale: number) {
  // Default browser font-size is 16px; scaling the <html> element scales every rem-based size,
  // including Mantine's own tokens.
  document.documentElement.style.fontSize = `${Math.round(16 * scale)}px`;
}
